<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="devices"
      :class="{
        opened: opened.indexOf('changeStatus') >= 0,
        'last-active': opened.indexOf('changeStatus') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleStatusConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="changeStatus()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("zmenitRezimU") }} {{ devices.length }}
          <span v-if="devices.length > 1">{{ $t("zarizeni") }}</span>
          <span v-else>{{ $t("zarizeni") }}</span>
        </h2>
      </div>
      <div class="side-box__content">
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label">{{ $t("prepnoutDoRezimu") }}</span>
          <div class="side-box__content__input custom-control__select ml-3">
            <div
              :class="{ opened: tagsOpened }"
              class="custom-control__select__selected d-flex"
              @click="tagsOpened = tagsOpened ? false : true"
            >
              <div class="d-flex flex-wrap">
                <span v-if="selectedState == ''" class="gray-text">{{ $t("vyberteRezim") }}</span>
                <div v-else class="">
                  <div v-if="selectedState == 'A'">
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--success mr-2">A</div>
                      <span>{{ $t("active") }}</span>
                    </div>
                  </div>
                  <div v-if="selectedState == 'S'">
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--gray mr-2">S</div>
                      <span>{{ $t("standby") }}</span>
                    </div>
                  </div>
                  <div v-if="selectedState == 'P'">
                    <div class="d-flex">
                      <div class="atom-circle atom-circle--warning mr-2">P</div>
                      <span>{{ $t("OPTION_PREDREGISTRACE") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ opened: tagsOpened }" class="custom-control__select__options">
              <div
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    selectedState = 'A'
                    tagsOpened = tagsOpened = false
                  }
                "
              >
                <div class="d-flex">
                  <div class="atom-circle atom-circle--success mr-2">A</div>
                  <span>{{ $t("active") }}</span>
                </div>
              </div>
              <div
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    selectedState = 'S'
                    tagsOpened = tagsOpened = false
                  }
                "
              >
                <div class="d-flex">
                  <div class="atom-circle atom-circle--gray mr-2">S</div>
                  <span>{{ $t("standby") }}</span>
                </div>
              </div>
              <div
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    selectedState = 'P'
                    tagsOpened = tagsOpened = false
                  }
                "
              >
                <div class="d-flex">
                  <div class="atom-circle atom-circle--warning mr-2">P</div>
                  <span>{{ $t("OPTION_PREDREGISTRACE") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedStatusConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleStatusConfirmation"
      @no="closeBox()"
      @yes="changeStatus()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <error-modal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    opened: Array,
    devices: Array,
    technology: {
      type: String,
      default: "lora"
    }
  },
  data() {
    return {
      tagsOpened: false,
      selectedState: "",
      openedStatusConfirmation: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    setProject() {},
    resetValues() {
      this.selectedState = ""
    },

    changeStatus() {
      this.errorsToTranslate = []
      if (this.selectedState == "A") {
        let promises = [];
        this.devices.forEach(device => {
          if (this.technology !== "udp") {
            promises.push(
              axios
                .post(
                  process.env.VUE_APP_API +
                  `/${this.technology}/devices/` +
                  device.deviceId +
                  "/activate",
                  {}
                )
                .then(() => {
                  device.enabled = true;
                })
                .catch(error => {
                  this.errorsToTranslate.push(error.data);
                })
            );
          }

          promises.push(
            axios
              .post(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId + "/enable", {})
              .then(() => {
                device.enabled = true
              })
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          )
        })
        Promise.all(promises).then(() => {
          this.openedError = true
          this.$emit("reloadItems")
          this.closeBox()
        })
      } else if (this.selectedState == "P") {
        let promises = []
        let err = []
        this.errorsToTranslate = []
        err.errors = []

        this.devices.forEach((device) => {
          let d = []
          // we must check, whether device is not in active state - there is no chance, to change this device to preactive state
          promises.push(
            axios
              .get(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId, {})
              .then((result) => {
                d = result.data.data
                console.log("change to preregistration data", d)
                if (d.status == "preregistration" || (d.status == "standby" && d.preregistration == true)) {
                  promises.push(
                    axios
                      .post(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId + "/enable", {})
                      .then(() => {
                        device.enabled = true
                      })
                      .catch((error) => {
                        this.errorsToTranslate.push(error.data)
                      })
                  )
                } else {
                  err.errors.push({
                    attribute: {
                      deviceId: device.deviceId
                    },
                    message: "ERROR_DEVICE_STATUS_TO_PREREGISTRATION"
                  })
                }
              })
              .catch(() => {})
          )
        })
        Promise.all(promises).then(() => {
          this.errorsToTranslate.push(err)
          this.openedError = true
          this.$emit("reloadItems")
          this.closeBox()
        })
      } else if (this.selectedState == "S") {
        let promises = []
        this.devices.forEach((device) => {
          promises.push(
            axios
              .delete(process.env.VUE_APP_API + `/${this.technology}/devices/` + device.deviceId + "/enable", {})
              .then(() => {
                device.enabled = false
              })
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          )
        })
        Promise.all(promises).then(() => {
          this.openedError = true
          this.closeBox()
        })
      }
    },
    toggleStatusConfirmation() {
      this.openedStatusConfirmation = this.openedStatusConfirmation ? false : true
    }
  }
}
</script>

<style lang="scss" scoped></style>
